module.exports = __webpack_public_path__ + "media/images/symbols/check-ed4b791ee4bfede3382ca8c4921be7a1.svg";